// STT プロバイダの解決と構築 (spec: docs/superpowers/specs/2026-07-30-stt-provider-switch-design.md §3.3)。
// 切り替えは URL パラメータ ?stt=openai のみ (D1)。値が "openai" のときだけ OpenAI、
// 未指定・未知値・非ブラウザはすべて elevenlabs に fail-open する (誤入力で経路が死なない)。
// 利用側 (useContinuousMode / singleUtteranceRecognizer) は makeSttClient() 経由で構築し、
// provider を知らない (原則 4 の薄いアダプタ)。

import { StreamingScribeClient } from "./streamingScribeClient";
import { StreamingOpenAiSttClient } from "./streamingOpenAiSttClient";
import type { SttProvider, StreamingSttClient, StreamingSttClientOpts } from "./streamingSttClient";

/**
 * 現在の URL から STT プロバイダを解決する。
 * 呼び出しのたびに window.location.search を読む (module-top const にしない) —
 * ?scribe-debug=1 (streamingScribeClient) / ?event-debug=1 (debugLogger) と同じ流儀で、
 * テストが history.replaceState で差し替えられるようにするため。
 */
export function resolveSttProvider(): SttProvider {
  if (typeof window === "undefined") return "elevenlabs";
  return new URLSearchParams(window.location.search).get("stt") === "openai"
    ? "openai"
    : "elevenlabs";
}

/** 解決したプロバイダで streaming STT クライアントを構築する。 */
export function makeSttClient(opts: StreamingSttClientOpts): StreamingSttClient {
  return resolveSttProvider() === "openai"
    ? new StreamingOpenAiSttClient(opts)
    : new StreamingScribeClient(opts);
}
